import { useState, FormEvent, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { getTaxValueInDTO } from "../..";
import Spinner from "../../../../../../components/Spinner";
import useAuthData from "../../../../../../hook/useAppData";
import { serviceUsers } from "../../../../service";
import { verefyIsEmpty } from "../../professional-data/libs";
import useFormStore from "../../store/useStore";
import { CLTCost } from "./components/CLTCost";
import { PJCost } from "./components/PJCost";

export type IFieldValuesBE = {
  dental_insurance: string;
  equipments: any;
  food_voucher: string;
  health_insurance: string;
  labor_benefits: string;
  life_insurance: string;
  meal_ticket: string;
  total: string;
};

export default function ContentPopUp({ regime }: any) {
  const { token, corporationId } = useAuthData();
  const { updateValue, resultCalcPreview, params, equipaments, tax } = useFormStore();
  const { setUpdateValues, setResultCalcPreview, setModalStatus, setEquipaments } = useFormStore();

  const [fieldsValue, setFieldsValues] = useState<IFieldValuesBE>({
    dental_insurance: "",
    food_voucher: "",
    health_insurance: "",
    life_insurance: "",
    meal_ticket: "",
    labor_benefits: "",
    total: "",
    equipments: "",
  });

  const [encargos, setEncargos] = useState();
  const [descanso, setDescanso] = useState();
  const [needSpinner, setNeedSpinner] = useState(true);

  useEffect(() => {
    if (!updateValue?.collaborator_cost?.cost) getBenefits();
    else getBenefitsInUpdateValue();
  }, []);

  function getBenefitsInUpdateValue() {
    setFieldsValues(updateValue?.collaborator_cost?.cost);
    setDescanso(updateValue?.collaborator_cost?.cost?.paid_vacation);
    setNeedSpinner(false);
  }

  const objId = {
    id: Number(params),
    pay: verefyIsEmpty(updateValue.data_professional, "monthly_pay", "hourly_pay", "*", updateValue?.hourBase),
    contract_type: regime,
    hourBase: String(updateValue?.hourBase),
    type_tax_id: getTaxValueInDTO(updateValue, tax)?.idField,
    type_tax_simple: getTaxValueInDTO(updateValue, tax)?.simple,
  };

  const obj = {
    pay: verefyIsEmpty(updateValue.data_professional, "monthly_pay", "hourly_pay", "*", updateValue?.hourBase),
    contract_type: regime,
    hourBase: String(updateValue?.hourBase),
    type_tax_id: getTaxValueInDTO(updateValue, tax)?.idField,
    type_tax_simple: getTaxValueInDTO(updateValue, tax)?.simple,
  };

  async function getBenefits() {
    const res = await serviceUsers.postBenefits(token, params ? objId : obj);
    const dados = await res.json();
    setFieldsValues(dados);
    if (dados?.equipments) setEquipaments(true);
    if (regime === "CLT") getBenefitsCLT(dados);
    else getBenefitsPJ(dados);
    setNeedSpinner(false);
  }

  function getBenefitsCLT(dados) {
    !updateValue.collaborator_cost.total &&
      setResultCalcPreview({
        total: dados?.total,
        cost_unity: dados?.cost_unity,
      });
    setEncargos(dados?.labor_benefits);
  }

  function getBenefitsPJ(dados) {
    !updateValue.collaborator_cost.total &&
      setResultCalcPreview({
        total: dados?.total,
        cost_unity: dados?.cost_unity,
      });
    setDescanso(dados?.paid_vacation);
  }

  async function handlePreview(e: FormEvent) {
    e.preventDefault();

    if (regime === "PJ") return handlePreviewPJ();
    return handlePreviewCLT();
  }

  async function handlePreviewPJ() {
    const obj = {
      contract_type: regime,
      pay: verefyIsEmpty(updateValue.data_professional, "monthly_pay", "hourly_pay", "*", updateValue?.hourBase),
      equipments: fieldsValue?.equipments,
      hourBase: String(updateValue?.hourBase),
      type_tax_id: getTaxValueInDTO(updateValue, tax)?.idField,
      type_tax_simple: getTaxValueInDTO(updateValue, tax)?.simple,
    };
    if (!equipaments) delete obj["equipments"];
    const data = await getPreviewCalc(obj);
    setResultCalcPreview(data);
    return setUpdateValues({
      ...updateValue,
      collaborator_cost: {
        ...updateValue.collaborator_cost,
        total: data.total,
      },
    });
  }

  async function handlePreviewCLT() {
    const obj = {
      contract_type: regime,
      pay: verefyIsEmpty(updateValue.data_professional, "monthly_pay", "hourly_pay", "*", updateValue.hoursBase),
      food_voucher: fieldsValue?.food_voucher,
      meal_ticket: fieldsValue?.meal_ticket,
      health_insurance: fieldsValue?.health_insurance,
      dental_insurance: fieldsValue?.dental_insurance,
      life_insurance: fieldsValue?.life_insurance,
      equipments: fieldsValue?.equipments,
      hourBase: String(updateValue?.hourBase),
      type_tax_id: getTaxValueInDTO(updateValue, tax)?.idField,
      type_tax_simple: getTaxValueInDTO(updateValue, tax)?.simple,
    };
    if (!equipaments) delete obj["equipments"];
    for (let key in obj) {
      if (!obj[key]) delete obj[key];
    }
    const data = await getPreviewCalc(obj);

    setResultCalcPreview(data);
    return setUpdateValues({
      ...updateValue,
      collaborator_cost: {
        ...updateValue.collaborator_cost,
        total: data.total,
        cost: obj,
      },
    });
  }

  async function getPreviewCalc(obj) {
    const res = await serviceUsers.postCalcs(token, obj);
    return await res.json(0);
  }

  function handleSubmitForm(e: FormEvent) {
    e.preventDefault();
    if (regime === "CLT") handleSubmitCLT();
    else handleSubmitPJ();
    setModalStatus(false);
  }

  function handleSubmitCLT() {
    const data = {
      ...updateValue.collaborator_cost,
      cost: benefitsCLt(),
      cost_unity: resultCalcPreview.cost_unity,
      total: resultCalcPreview.total,
    };

    function benefitsCLt() {
      return {
        food_voucher: fieldsValue?.food_voucher,
        meal_ticket: fieldsValue?.meal_ticket,
        health_insurance: fieldsValue?.health_insurance,
        dental_insurance: fieldsValue?.dental_insurance,
        labor_benefits: encargos,
        equipments: fieldsValue?.equipments,
        life_insurance: fieldsValue?.life_insurance,
      };
    }
    setUpdateValues({ ...updateValue, collaborator_cost: data });
  }

  function handleSubmitPJ() {
    const calcPJ = {
      ...updateValue.collaborator_cost,
      cost: costPJ(),
      cost_unity: resultCalcPreview.cost_unity,
      total: resultCalcPreview.total,
    };

    function costPJ() {
      return {
        paid_vacation: descanso,
        equipments: fieldsValue?.equipments,
      };
    }

    setUpdateValues({ ...updateValue, collaborator_cost: calcPJ });
  }

  return (
    <>
      <Spinner classNameFather="width-100" status={needSpinner}>
        <Toaster />
        <form onSubmit={handleSubmitForm} className="container-modal">
          {regime === "PJ" ? (
            <PJCost
              fieldsValue={fieldsValue}
              setFieldValue={setFieldsValues}
              paidVacation={descanso}
              corporationId={corporationId}
              equipaments={equipaments}
              setEquipaments={setEquipaments}
            />
          ) : (
            <CLTCost
              fieldsValue={fieldsValue}
              setFieldValue={setFieldsValues}
              encargos={encargos}
              equipaments={equipaments}
              setEquipaments={setEquipaments}
            />
          )}
          <div className="box-row row-with-button between">
            <button className="btn bg-primary border-none color-text-contrast" type="submit">
              Salvar
            </button>
            <button className="btn-calc-cost btn bg-secondary border-none color-text-contrast" onClick={handlePreview} type="button">
              Calcular
            </button>
          </div>
        </form>
      </Spinner>
    </>
  );
}
